import styles from './styles.module.css';
import Modal from 'react-responsive-modal';
import confirmRegister from '../../../../assets/images/confirmRegister.png';
import { Button } from '../../../../components/Button';

interface IModalConfirmDeletePlayer {
  modalIsOpen: boolean;
  toggleModal: () => void;
  confirmeDelete: () => void;
}

export function ModalConfirmDeletePlayer({
  modalIsOpen,
  toggleModal,
  confirmeDelete,
}: IModalConfirmDeletePlayer) {
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={confirmRegister} alt="" />
        </div>
        <h1 className="title-modal">Tem certeza?</h1>
        <p className="subtitle-modal">
          Após confirmar não será possível desfazer essa ação.
        </p>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Confirmar"
          type="button"
          color="primary"
          onClick={() => {
            toggleModal();
            confirmeDelete();
          }}
        />
      </div>
    </Modal>
  );
}
